<template>
  <div v-if="props.isOpen" class="fixed z-30">
    <div
      class="relative z-30 px-5 flex justify-center items-center w-screen h-screen"
    >
      <div class="bg-primary-white py-6 px-[32px] rounded-3xl space-y-6">
        <div class="text-2xl font-bold">{{ props.title }}</div>
        <div class="text-base mt-4 max-w-[600px]">
          {{ props.message }}
        </div>
        <div class="flex justify-end">
          <div
            class="min-w-[50%] border-[1px] border-border-divider rounded-2xl font-bold py-3 bg-gray-10 text-center cursor-pointer"
            @click="handleClose"
          >
            {{ props.buttonText }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="fixed top-0 left-0 z-10 w-screen h-screen bg-primary-black opacity-80"
    />
  </div>
</template>

<script lang="ts" setup>
import scrollLock from 'scroll-lock'

const props = defineProps<{
  title: string
  message: string
  buttonText: string
  isOpen: boolean
}>()

const emit = defineEmits<{
  (e: 'close'): void
}>()

watch(
  () => props.isOpen,
  (isOpen) => {
    if (isOpen) {
      scrollLock.disablePageScroll()
    } else {
      scrollLock.enablePageScroll()
    }
  }
)

const handleClose = () => {
  emit('close')
}
</script>
